import './_temas.scss';
import '../../css/partials/_colors.scss';
import CardHeadTemas from '../../components/cardTemas/cardHeadTemas';
import CardTema from '../../components/cardTema/cardTema';
import { useEffect, useState, useContext } from 'react';
import { AuthContext } from '../../contexts/auth';
import { ManagerProgressContext } from '../../contexts/managerProgres';
import Loading from '../../components/loading/loading';
import axios from 'axios';
import configeToken from '../../services/api';
import { useNavigate } from 'react-router-dom';
import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
} from '@mui/material';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

function Temas() {
    const { updateToken, logoutLogin, cyrcleStorage, refreshCycles } = useContext(AuthContext)
    const { concluded, lastTheme } = useContext(ManagerProgressContext)
    const [getTemas, setGetTemas] = useState([])
    const [removeLoading, setRemoveLoading] = useState(false)
    const [permission, setPermission] = useState(false);
    const [companyRoleId, setCompanyRoleId] = useState(null)
    const [concludedTemas, setConcludedTemas] = useState(false)
    const [open, setOpen] = useState(false)
    const navigate = useNavigate()

    useEffect(() => {
        const interceptor = axios.interceptors.response.use(
            response => response,
            error => {
                if (error.response && error.response.status === 401) {
                    logoutLogin();
                }
                return Promise.reject(error);
            }
        );

        return () => {
            axios.interceptors.response.eject(interceptor);
        };
    }, [logoutLogin]);

    useEffect(() => {
        document.title = 'Abrafati - Temas'
        refreshCycles();
        const userStorage = JSON.parse(localStorage.getItem('@user'));
        const permissions = userStorage?.permissions || [];
        const hasPermission = permissions.some(permission => permission.id === 2);

        if (hasPermission) {
            setPermission(true);
        } else {
            console.warn("[REDIRECT] Temas (/): Usuário não possui permissão de temas (permissão id: 2). Redirecionando para /downloads.", {
                user: userStorage,
                permissions: permissions,
            });
            toast.info("Seu perfil de acesso não possui permissão para preencher o questionário.", {
                toastId: "sem-permissao-acesso",
            });
            navigate('/downloads');
        }
    }, [navigate, refreshCycles])

    useEffect(() => {
        if (!cyrcleStorage) return;

        const userStorage = JSON.parse(localStorage.getItem('@user'));
        const permissions = userStorage?.permissions || [];
        const hasPermission = permissions.some(p => p.id === 2);
        if (!hasPermission) return;

        updateToken()
            .then(() => configeToken())
            .then(() => {
                const headers = {
                    "Authorization": `Bearer ${localStorage.getItem('@token')}`,
                    "Content-Type": "application/json",
                    "Accept": "application/json",
                };

                axios({ method: "get", url: `${process.env.REACT_APP_API_URL}/pesquisa/${cyrcleStorage}`, headers })
                    .then((response) => {
                        setGetTemas(response.data.data.themes)
                        setCompanyRoleId(response.data.data.company_role_id)
                        setConcludedTemas(response.data.data.concluded)
                        setRemoveLoading(true)
                    })
                    .catch(error => {
                        if (error.response && error.response.status === 401) {
                            logoutLogin();
                        }
                    });
            })
    }, [cyrcleStorage, logoutLogin, updateToken])

    async function endSearch(quiz_id) {
        const headers = {
            Authorization: `Bearer ${localStorage.getItem('@token')}`,
            'Content-Type': 'application/json',
            Accept: 'application/json',
        };

        let responseFetch;
        try {
            const response = await fetch(
                `${process.env.REACT_APP_API_URL}/finalizar`,
                {
                    method: 'POST',
                    headers,
                    body: JSON.stringify({ quiz_id }),
                },
            );
            responseFetch = await response.json();

            if (response.ok) {
                toast.success(responseFetch.message, {
                    position: 'bottom-right',
                    autoClose: 3000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    theme: 'light',
                });
            } else {
                throw responseFetch;
            }
        } catch (error) {
            toast.warn(responseFetch ? responseFetch.message : String(error), {
                position: 'bottom-right',
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                theme: 'light',
            });
        }
    }

    const handleClickOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);
    const handleConfirmFinalize = () => {
        endSearch(cyrcleStorage);
        handleClose();
    };

    return (
        <div className='container-temas'>
            {!removeLoading ? <Loading /> : (
                <>
                    {
                        permission ? (
                            <main className='container-temas-main'>
                                <CardHeadTemas getTemas={getTemas} company_role_id={companyRoleId} />
                                {
                                    getTemas.map(el => <CardTema key={el.id} idTema={el.id} subthemes={el.subthemes} progress={Math.round(el.progress)} title={el.title} introduction={el.introduction} image={el.image} temaBg={`bg-${el.id}`} temaColor={`color-${el.id}`} />)
                                }

                                {(() => {
                                    const allThemesDone = getTemas.length > 0 && getTemas.every(el => Math.round(el.progress) === 100);
                                    return !concludedTemas && allThemesDone && (
                                        <div className='btn-finalizar-wrapper'>
                                            <button
                                                onClick={handleClickOpen}
                                                className='btn-send-request'
                                                type='button'
                                            >
                                                Finalizar
                                            </button>
                                        </div>
                                    );
                                })()}

                                <Dialog
                                    open={open}
                                    onClose={handleClose}
                                    aria-labelledby="alert-dialog-title"
                                    aria-describedby="alert-dialog-description"
                                >
                                    <DialogTitle id="alert-dialog-title">
                                        {'Finalizando questionário'}
                                    </DialogTitle>
                                    <DialogContent>
                                        <DialogContentText id="alert-dialog-description">
                                            Ao confirmar você finalizará o questionário, deseja continuar?
                                        </DialogContentText>
                                    </DialogContent>
                                    <DialogActions>
                                        <Button onClick={handleClose}>Não</Button>
                                        <Button onClick={handleConfirmFinalize} autoFocus>
                                            Confirmar
                                        </Button>
                                    </DialogActions>
                                </Dialog>
                            </main>
                        ) : null
                    }
                </>
            )}
        </div>
    )
}

export default Temas;
